import "./index.css"; // Assuming you have a CSS file for styling

import React, { useState } from "react";
const SettlmentTooltipBtn = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(true);

  const options = [
    { option: "paid", tooltip: "تسویه شده", color: "green" },
    { option: "submitted", tooltip: "آماده تسویه", color: "#FFB319" },
    { option: "pending_for_settlement", tooltip: "درانتظار تسویه", color: "blue" },
  ];

  const item = options.find((entry) => entry.option === value);
  const tooltip = item ? item.tooltip : "*";
  const color = item ? item.color : "*";

  return (
    <div className="settlement-tooltip-container">
      <div
        className={`settlement-tooltip-btn ${item.className}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V8.5C22 8.77614 21.7761 9 21.5 9L2.5 9C2.22386 9 2 8.77614 2 8.5V8ZM2.5 11C2.22386 11 2 11.2239 2 11.5V16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16V11.5C22 11.2239 21.7761 11 21.5 11L2.5 11ZM13 15C13 14.4477 13.4477 14 14 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14C13.4477 16 13 15.5523 13 15Z"
            fill={color}
          />
        </svg>
        {showTooltip && <div className="tooltip">{tooltip}</div>}
      </div>
    </div>
  );
};

export default SettlmentTooltipBtn;
